// src/pages/Users/Inscription/components/ConsentPanel.jsx

import React from "react";
import {
  FaCamera,
  FaCheckCircle,
  FaClipboardCheck,
  FaExclamationTriangle,
} from "react-icons/fa";

import StepCard from "./StepCard";

function CheckboxLine({
  name,
  checked,
  onChange,
  title,
  description,
  icon,
  required,
}) {
  return (
    <label className="flex cursor-pointer items-start gap-4 rounded-3xl border border-slate-200 bg-slate-50 p-4 transition hover:bg-white dark:border-slate-800 dark:bg-slate-950/70 dark:hover:bg-slate-900">
      <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-white text-indigo-700 shadow-sm ring-1 ring-slate-200 dark:bg-slate-900 dark:text-indigo-300 dark:ring-slate-700">
        {icon}
      </span>

      <span className="min-w-0 flex-1">
        <span className="block text-sm font-bold text-slate-900 dark:text-white">
          {title}
          {required ? <span className="ml-1 text-rose-500">*</span> : null}
        </span>

        {description ? (
          <span className="mt-1 block text-sm leading-6 text-slate-600 dark:text-slate-300">
            {description}
          </span>
        ) : null}
      </span>

      <input
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        required={required}
        className="mt-2 h-5 w-5 shrink-0 accent-indigo-600"
      />
    </label>
  );
}

export default function ConsentPanel({ formData, handleChange }) {
  return (
    <StepCard
      step="5"
      title="Autorisations et validations"
      icon={<FaClipboardCheck />}
      description="Merci de vérifier les autorisations et les engagements nécessaires à la finalisation de l’inscription."
    >
      <div className="grid gap-4 lg:grid-cols-2">
        <CheckboxLine
          name="autorisation_photo"
          checked={!!formData.autorisation_photo}
          onChange={handleChange}
          icon={<FaCamera />}
          title="Autorisation photo"
          description="J’autorise le club à utiliser des photos de l’adhérent dans le cadre de la communication du club. Si décoché, une image d’interdiction photo sera utilisée."
        />

        <CheckboxLine
          name="accept_reglement"
          checked={!!formData.accept_reglement}
          onChange={handleChange}
          icon={<FaCheckCircle />}
          title="Règlement intérieur"
          description="Je reconnais avoir pris connaissance du règlement intérieur et m’engage à le respecter."
          required
        />

        <CheckboxLine
          name="accept_infos_exactes"
          checked={!!formData.accept_infos_exactes}
          onChange={handleChange}
          icon={<FaCheckCircle />}
          title="Informations exactes"
          description="Je certifie que les informations renseignées dans ce formulaire sont exactes."
          required
        />

        <CheckboxLine
          name="accept_responsabilite"
          checked={!!formData.accept_responsabilite}
          onChange={handleChange}
          icon={<FaExclamationTriangle />}
          title="Responsabilité"
          description="Je m’engage à signaler toute information importante concernant la santé ou la situation de l’adhérent."
          required
        />
      </div>

      <div className="mt-5 rounded-3xl border border-amber-200 bg-amber-50 p-4 text-sm leading-6 text-amber-900 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-200">
        Les cases obligatoires doivent être cochées pour permettre la validation
        du dossier d’inscription.
      </div>
    </StepCard>
  );
}